import Button from 'components/Button';
import DataTable from 'components/DataTable';
import ListActionsWrapper from 'components/ListActionsWrapper';
import ListWrapper from 'components/ListWrapper';
import SearchInput from 'components/SearchInput';
import PageHeader from 'components/PageHeader';
import Typography from 'components/Typography';
import Filter from 'components/Filter';

import useEmployees from './useEmployees';

import styles from './Employees.module.scss';
import {DataTableSchemaItem} from 'types';

const SCHEMA: DataTableSchemaItem[] = [
  {
    dataKey: 'name',
    header: 'Full Name',
    sortable: true,
  },
  {
    dataKey: 'phone',
    header: 'Phone Number',
    sortable: true,
  },
  {
    dataKey: 'role',
    header: 'Role',
    sortable: true,
  },
  {dataKey: 'view', header: '', colWidth: '150px'},
];

function Employees() {
  const {
    data,
    isLoading,
    filterOptions,
    filterValue,
    sortBy,
    sortOrder,
    onChangeFilter,
    onSort,
    keyWord,
    setKeyWord,
    goToCreate,
  } = useEmployees();

  return (
    <>
      <PageHeader>
        <Typography variant="h2">Staff</Typography>
        <Button onClick={goToCreate}>New Staff</Button>
      </PageHeader>

      <ListWrapper>
        <ListActionsWrapper className={styles.list_header}>
          <SearchInput
            value={keyWord}
            onChange={(val) => {
              setKeyWord(val.target.value);
              sessionStorage.setItem(`search_employe`, val.target.value);
            }}
            size="sm"
          />
          <Filter
            size="sm"
            options={filterOptions}
            value={filterValue}
            onChange={onChangeFilter}
          />
        </ListActionsWrapper>
        <DataTable
          sortBy={sortBy}
          sortOrder={sortOrder}
          onSort={onSort}
          selectable={false}
          data={data}
          schema={SCHEMA}
          loading={isLoading}
        />
      </ListWrapper>
    </>
  );
}

export default Employees;
